export const errSelDataMsg = {
    typeErr : 'ข้อมูลที่ได้รับไม่ถูกต้อง'
}